<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="add">
        <p>
          <span class="add__back">
            <routerLink to="/settings">User Management</routerLink>
          </span>
          >
          <span class="add__current">Add Admin</span>
        </p>
        <div class="add__container">
          <div class="add__container--avatar">
            <img src="./../../../assets/images/employee.svg" alt="avatar" />
          </div>
          <div class="add__container--text">
            <span
              >You Too Deserve To Let Someone Else Manage Somethings For
              You</span
            >
            <p>
              Tell us who you’re adding and what type of access to give them.
              Once your new admin is added, we’ll send them the details.
            </p>
          </div>
          <div class="edit__container--loader" v-show="pageLoading">
            <div>
              <PageLoader />
            </div>
          </div>
          <div class="add__container--details" v-show="!pageLoading">
            <div>
              <div class="add__container--details-left">Select Account:</div>
              <div class="add__container--details-right">
                <select
                  v-model="selectedEmployee"
                  class="add__container--details-right-select"
                  v-show="employee"
                >
                  <option value="">-- select --</option>
                  <option
                    v-for="employeeValue in employeeList"
                    v-bind:key="employeeValue.index"
                    :value="employeeValue.id"
                  >
                    {{ employeeValue.name }}
                  </option>
                </select>
                <div
                  class="add__container--details-right-select-loader"
                  v-show="!employee"
                >
                  <InputLoader />
                </div>
              </div>
            </div>


                     <div>
              <div class="add__container--details-left">Permissions:</div>
              <div class="add__container--details-right">
                <div class="permissionList" v-for="(permission, index) in permissionsArray" :key="permission.slug">
                  <input :value="permission.slug" class="checkbox__btn" type="checkbox" v-model="selectedPermissions"
                    :disabled="index !== 0 && disableCheckboxes" @change="handleCheckboxChange(permission.slug)" />

                  <div>
                    <p class="permission_title">{{ permission.title }}</p>
                    <p class="permission_description">
                      {{ permission.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
          <div class="add__container--error" v-show="!pageLoading">
            <span v-show="networkError"
              >We experienced a network error. Please try again.</span
            >
            <span v-show="successMsg">Admin added successfully.</span>
            <span v-show="formError">You have not selected an employee.</span>
            <span v-show="individualError"
              >You have not selected a resource.</span
            >
          </div>
          <div class="add__container--btn" v-show="!pageLoading">
            <button @click.prevent="addAdmin" v-show="!loader">
              Add New Admin
            </button>
            <div v-show="loader">
              <WhiteLoader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import InputLoader from "../../partials/input-loader";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

import * as types from "../../../store/constant";

export default {
  name: "AddAdmin",
  components: {
    Header,
    Sidebar,
    InputLoader,
    WhiteLoader,
    PageLoader,
  },
  data() {
    return {
      pageLoading: true,
      item: "setting",
      networkError: false,
      successMsg: false,
      formError: false,
      individualError: false,
      loader: false,
      employee: false,
      disableCheckboxes: false,
      selectedPermissions: [],
      selectedEmployee: "",
      permission: "full",
      employeeList: [],
      employeeArray: [],
      permissionsArray: []
    };
  },
  methods: {
    addAdmin() {
      this.networkError = false;
      this.successMsg = false;
      this.formError = false;
      this.individualError = false;

      if (!this.selectedEmployee) {
        this.formError = true;
        return;
      }

      this.loader = true;

      const addAdminData = {
        user_id: this.selectedEmployee,
        permissions: this.selectedPermissions,
      };

      // TODO
      this.$http
        .post(types.ADD_ADMIN_API, addAdminData)
        .then((resp) => {
          this.$router.push("/settings");

        })
        .catch((error) => {
          this.loader = false;
          this.networkError = true;
        });
    },
    getNonAdmins() {
      return this.$http.get(types.GET_NON_EMPLOYEES_API);
    },
    getPermissionsList() {
      return this.$http.get(types.PERMISSION_API);
    },
    handleCheckboxChange(slug) {
      if (slug === "*") {
        this.disableCheckboxes = !this.disableCheckboxes
      }
    }
  },
  created() {
    this.pageLoading = true;

    this.$http.all([this.getNonAdmins(), this.getPermissionsList()]).then(
      this.$http.spread((employee, permissions) => {
        if (employee) {
          this.employee = true;
          this.employeeArray = [...employee.data.data.data];
          this.employeeArray.forEach((value) => {
            this.employeeList.push({
              id: value.user.id,
              name:
                value.user.firstname +
                " " +
                (value.user.middlename ? value.user.middlename : "") +
                " " +
                value.user.lastname,
            });
          });
        }

        if (permissions) {
          this.permissionsArray = [...permissions.data.data];
        }
        this.pageLoading = false;
      })
    );
  },
};
</script>

<style lang="scss" scoped>

.add {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  > p {
    font-size: 0.938vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .add__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .add__current {
      color: #707070;
    }
  }

  .permissionList {
    display: flex;
    // align-items: baseline;
    margin-bottom: 8px;

    > input {
      margin-right: 10px;
    }
  }



  .permission_title {
    margin-bottom: 0;
  }
  .permission_description {
    font-size: 12px;
    color: #707070;
  }
  .checkbox__btn {
    width: 20px;
    height: 20px;
    border: solid 1px #707070;
    background-color: #ffffff;
  }

  .add__container--btn {
    display: flex;
    justify-content: center;
  }

  .add__container {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding-top: 20px;
    padding-bottom: 80px;
    padding-left: 12.865vw;
    padding-right: 12.865vw;

    > .add__container--avatar {
      width: 5.365vw;
      margin: auto;
    }

    > .add__container--text {
      margin-top: 50px;
      text-align: center;

      > span {
        font-size: 1.458vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #000000;
      }

      > p {
        font-size: 0.833vw;
        font-weight: 200;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.88;
        letter-spacing: normal;
        margin-top: 20px;
        color: #000000;
      }
    }

    > .edit__container--loader {
      margin-top: 50px;

      > div {
        width: 55px;
        margin: auto;
      }
    }

    > .add__container--details {
      margin: 50px 0;

      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: center;
        align-content: center;
        margin-bottom: 50px;

        > .add__container--details-left {
          width: 20.833vw;
          font-size: 1.042vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        > .add__container--details-right {
          width: calc(100% - 20.833vw);

          > .add__container--details-right-radio {
            overflow: hidden;
            margin-bottom: 30px;

            > .add__container--details-right-radio-left {
              width: 20px;
              height: 20px;
              border-radius: 50px;
              float: left;

              > input {
                width: 20px;
                height: 20px;
                border: solid 1px #707070;
                background-color: #ffffff;
              }
            }

            > .add__container--details-right-radio-right {
              width: calc(100% - 30px);
              padding-left: 10px;
              height: 20px;
              float: left;
              font-size: 1.042vw;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.5;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }
          }

          > .add__container--details-right-check {
            overflow: hidden;
            margin-bottom: 30px;

            > .add__container--details-right-check-left {
              width: 20px;
              height: 20px;
              float: left;

              > input {
                width: 20px;
                height: 20px;
                border: solid 1px #707070;
                background-color: #ffffff;
              }
            }

            > .add__container--details-right-check-right {
              width: calc(100% - 20px);
              padding-left: 10px;
              height: 20px;
              float: left;
              font-size: 1.042vw;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.5;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }
          }

          > .add__container--details-right-select {
            height: 45.5px;
            border-radius: 1px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            outline: 0;
            font-size: 1.042vw;
          }

          > .add__container--details-right-select-loader {
            height: 45.5px;
            border-radius: 1px;
            background-color: #ffffff;
            border: solid 1px #c7c7c7;
            outline: 0;
            font-size: 1.042vw;
          }
        }
      }
    }

    .add__container--error {
      height: 50px;
      font-size: 0.938vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: left;
      color: red;
      margin-top: 20px;
      font-style: italic;
    }

    .add__container--btn {
      > button {
        width: 12.135vw;
        height: 55px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 0.938vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
        border: 0;
        outline: 0;
      }
      > div {
        width: 12.135vw;
        height: 55px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 0.938vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }
}
</style>